module.exports = __webpack_public_path__ + "static/img/physical_harm_2.613a7a76.png";